// Spread a run of video parts over the days a student works. Pure, so it is easy to test.
// days: weekday numbers, 0 = Sunday ... 6 = Saturday. Dates are YYYY-MM-DD strings (the student's calendar day).

const parse = (s) => { const [y, m, d] = s.split('-').map(Number); return new Date(y, m - 1, d, 12); };   // noon: safe across DST
const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export function buildSchedule({ from, to, perDay, days, startDate }) {
  from = Number(from); to = Number(to); perDay = Number(perDay);
  if (!(from >= 1) || !(to >= from) || !(perDay >= 1) || !days.length || !/^\d{4}-\d{2}-\d{2}$/.test(startDate || '')) return [];
  const out = [];
  const day = parse(startDate);
  for (let p = from; p <= to; p += perDay) {
    while (!days.includes(day.getDay())) day.setDate(day.getDate() + 1);
    out.push({ part_from: p, part_to: Math.min(p + perDay - 1, to), assigned_date: fmt(day) });
    day.setDate(day.getDate() + 1);
  }
  return out;
}

export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const todayLocal = () => new Date().toLocaleDateString('en-CA');   // YYYY-MM-DD in this computer's timezone
